import type { ComponentProps } from 'react';
import { useRef } from 'react';

import { cn, useIsClamped } from '@crm/shared/lib';

import { DealTableCell } from '../DealTableCell';

import type { TDeal } from '../../model/deal';

type CustomerNameCellProps = Pick<TDeal, 'customerName'> &
    Pick<ComponentProps<typeof DealTableCell>, 'className'>;

export const CustomerNameCell = ({ className, customerName }: CustomerNameCellProps) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(textRef);

    return (
        <DealTableCell
            isEmpty={!customerName}
            title={isClamped ? customerName : undefined}
            className={cn('max-w-32.5 px-1 py-2', className)}
        >
            <p ref={textRef} className="min-w-0 truncate">
                {customerName}
            </p>
        </DealTableCell>
    );
};
